module.exports = __webpack_public_path__ + "assets/img/teacher (14).49dd995e.png";